var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"8"}},[_c('welcome-card'),_c('planning-card'),_c('performance-card')],1),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('reviews-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }